/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:07:46 
 * @Last Modified by:   pcjser 
 * @Last Modified time: 2018-04-19 09:07:46 
 */
import React from 'react';

const NoMatch = () => (
  <div className="component-nomatch">
    404 Not Found!
  </div>
)

export default NoMatch;


// WEBPACK FOOTER //
// ./src/components/NoMatch/index.jsx